import type { TokenInfo } from '@/config/tokens';
import { type PropsWithChildren, createContext, useContext, useState } from 'react';
export type WithdrawContextProps = {
  activeTab: TokenInfo['symbol'] | 'other' | 'crypto';
  setActiveTab: (tab: string) => void;
};
const WithdrawContext = createContext<WithdrawContextProps | null>(null);
export const WithdrawProvider: React.FC<PropsWithChildren> = ({
  children
}) => {
  const [activeTab, setActiveTab] = useState<string>('USDT');
  return <WithdrawContext.Provider value={{
    activeTab,
    setActiveTab
  }}>
      {children}
    </WithdrawContext.Provider>;
};
export const useWithdraw = () => {
  const context = useContext(WithdrawContext);
  if (!context) {
    throw new Error('useWithdraw must be used within a WithdrawProvider');
  }
  return context;
};